export const RESTFieldType = {
    Blob: "esriFieldTypeBlob",
    Date: "esriFieldTypeDate",
    Double: "esriFieldTypeDouble",
    Geometry: "esriFieldTypeGeometry",
    GlobalID: "esriFieldTypeGlobalID",
    GUID: "esriFieldTypeGUID",
    Integer: "esriFieldTypeInteger",
    OID: "esriFieldTypeOID",
    Raster: "esriFieldTypeRaster",
    Single: "esriFieldTypeSingle",
    SmallInteger: "esriFieldTypeSmallInteger",
    String: "esriFieldTypeString",
    XML: "esriFieldTypeXML"
};
export const RESTStatisticType = {
    Count: "count",
    Sum: "sum",
    Minimum: "min",
    Maximum: "max",
    Average: "avg",
    StandardDeviation: "stddev",
    Variance: "var",
    ContinuousPercentile: "percentile_cont",
    DiscretePercentile: "percentile_disc",
    EnvelopeAggregate: "envelope-aggregate",
    CentroidAggregate: "centroid-aggregate",
    ConvexHullAggregate: "convex-hull-aggregate",
    NoAggregation: "no_aggregation" // TODO: that property needs to be exported to another interface, as it is not REST compatible (see issue #2352)
};
export const RESTSimpleLineSymbolStyle = {
    Dash: "esriSLSDash",
    DashDot: "esriSLSDashDot",
    DashDotDot: "esriSLSDashDotDot",
    Dot: "esriSLSDot",
    Null: "esriSLSNull",
    Solid: "esriSLSSolid"
};
export const RESTSimpleMarkerSymbolStyle = {
    Circle: "esriSMSCircle",
    Cross: "esriSMSCross",
    Diamond: "esriSMSDiamond",
    Square: "esriSMSSquare",
    X: "esriSMSX",
    Triangle: "esriSMSTriangle"
};
export const RESTSimpleFillSymbolStyle = {
    BackwardDiagonal: "esriSFSBackwardDiagonal",
    Cross: "esriSFSCross",
    DiagonalCross: "esriSFSDiagonalCross",
    ForwardDiagonal: "esriSFSForwardDiagonal",
    Horizontal: "esriSFSHorizontal",
    Null: "esriSFSNull",
    Solid: "esriSFSSolid",
    Vertical: "esriSFSVertical"
};
export const RESTHorizontalAlignment = {
    Left: "left",
    Right: "right",
    Center: "center",
    Justify: "justify"
};
export const RESTVerticalAlignment = {
    Baseline: "baseline",
    Top: "top",
    Middle: "middle",
    Bottom: "bottom"
};
export const RESTSymbolType = {
    SLS: "esriSLS",
    SMS: "esriSMS",
    SFS: "esriSFS",
    PMS: "esriPMS",
    PFS: "esriPFS",
    TS: "esriTS"
};
export const RESTFontStyle = {
    Italic: "italic",
    Normal: "normal",
    Oblique: "oblique"
};
export const RESTFontWeight = {
    Bold: "bold",
    Bolder: "bolder",
    Lighter: "lighter",
    Normal: "normal"
};
export const RESTFontDecoration = {
    LineThrough: "line-through",
    Underline: "underline",
    None: "none"
};
export const RESTRendererType = {
    UniqueValue: "unique-value",
    Simple: "simple",
    ClassBreaks: "class-breaks",
    Heatmap: "heatmap",
    DotDensity: "dot-density",
    Dictionary: "dictionary",
    PieChart: "pie-chart"
};
export const RESTUnits = {
    Feet: "feet",
    Miles: "miles",
    NauticalMiles: "nautical-miles",
    USNauticalMiles: "us-nautical-miles",
    Meters: "meters",
    Kilometers: "kilometers"
};
